import { render, staticRenderFns } from "./ExportButtons.vue?vue&type=template&id=0c568c86&scoped=true"
import script from "./ExportButtons.vue?vue&type=script&lang=js"
export * from "./ExportButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c568c86",
  null
  
)

export default component.exports